<template>
    <div>
        <MyAppointments sub-program-id="SubProgramId" />
    </div>
</template>

<script>
    import MyAppointments from './Appointments/MyAppointments.vue';

    export default {
        name: "EmbedMyAppointments",
        props: [

        ],
        data: function () {
            return {
                
            }
        },
        methods: {
            
        },
        components: {
            MyAppointments
        },
        computed: {
            SubProgramId: function () {
                return this.$route.query.SubProgramId
            },
        },
    }
</script>